import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

import { InlineOverlay, InlineOverlayHeader, InlineOverlayBody, InlineOverlayFooter, InlineOverlayCloseButton } from '@bibliocommons/base-inline-overlay';
import BibBrief from '@bibliocommons/shared-bib-brief';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { Checkmark } from '@bibliocommons/base-icons';

import HoldsPauseDateSelect from '../../HoldsPauseDateSelect';

import '../styles/BasePauseHoldWorkflowView.scss';

export default class BasePauseHoldWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);

    this.state = {
      suspendDates: {
        startDate: props.initialSuspendStartDate || null,
        endDate: props.initialSuspendEndDate || null
      }
    };

    this.bindAll('handlePauseUpdate');
  }

  handlePauseUpdate() {
    const { suspendDates } = this.state;
    this.props.handleHoldPauseDate(suspendDates);
  }

  renderBibInfo() {
    const { bibs, holdIds } = this.props;
    const bib = bibs.first();
    const showBrief = (holdIds.size === 1 && bib);

    return showBrief && (
      <BibBrief
        bib={bib}
        titleTag="h3"
        renderTitleAsLink={false}
        renderAuthorsAsLink={false} />
    );
  }

  render() {
    const { startDate, endDate } = this.state.suspendDates;
    const { isLoading, handleClose, enableStartDate, enableEndDate } = this.props;

    return (
      <div className="cp-base-pause-hold-workflow-view">
        <InlineOverlay handleClose={handleClose}>
          <InlineOverlayHeader>
            <FormattedMessage id="pause_confirmation_hold_title" />
          </InlineOverlayHeader>
          <InlineOverlayBody>
            {this.renderBibInfo()}
            <FormattedMessage id="pause_workflow_info_text" />
            <div className="cp-pause-hold-workflow-date item-row">
              <HoldsPauseDateSelect
                fullScreen
                enableStartDate={enableStartDate}
                enableEndDate={enableEndDate}
                initialSuspendStartDate={this.props.initialSuspendStartDate}
                initialSuspendEndDate={this.props.initialSuspendEndDate}
                onSelectDates={(suspendDates) => this.setState({ suspendDates })} />
            </div>
          </InlineOverlayBody>
          <InlineOverlayFooter>
            <div className="col-xs-12">
              <PrimaryButton className="pull-right" isLoading={isLoading} handleClick={this.handlePauseUpdate} disabled={(!startDate && enableStartDate) || (!endDate && enableEndDate)}>
                <Checkmark color="#FFF" /> <FormattedMessage id="pause_confirmation_hold_button_yes" />
              </PrimaryButton>
              <InlineOverlayCloseButton className="btn btn-link pull-right">
                <FormattedMessage id="button_nevermind_close" />
              </InlineOverlayCloseButton>
            </div>
          </InlineOverlayFooter>
        </InlineOverlay>
      </div>
    );
  }
}

BasePauseHoldWorkflowView.propTypes = {
  bibs: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  holdsId: PropTypes.string,
  pauseHold: PropTypes.func,
  handleHoldPauseDate: PropTypes.func.isRequired,
  initialSuspendStartDate: PropTypes.string,
  initialSuspendEndDate: PropTypes.string,
  enableStartDate: PropTypes.bool,
  enableEndDate: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/PauseHoldWorkflowView/components/BasePauseHoldWorkflowView.jsx